import { BRAND } from "../config";

export const isPartner = (companyId: string, parentCompanyId: string, userCompanyId: string): boolean => {
    if (userCompanyId === BRAND) {
        return false;
    }

    return userCompanyId !== companyId && userCompanyId !== parentCompanyId;
};